import React, { useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { extend } from '../../services/userProfile'
import { shouldForceUserRefresh } from '../../lib/user'
import LoadingScreen from '../LoadingScreen'
import MainUI from '../MainUI'
import MapView from '../MapView'
import ModalView from '../ModalView'
import Alert from '../Modals/Alert'
function App(props) {
  /*
    #NOTE: Make sure the timing is correct between this and loading the map. It should
    be fine because Firebase is asking for way less data, and if both are running in parallel
    with network being the only overhead, then this will win all the time.
    -- TJC - May 13, 2020
  */

  useEffect(() => {
    props.dispatch({
      type: 'app/setConfig',
      payload: props.appConfig
    })
  })

  useEffect(() => {
    props.dispatch({
      type: 'app/setFirebaseDone',
      payload: true
    })

    props.dispatch({
      type: 'map/initBasemap',
      payload: props.basemaps
    })

    props.dispatch({
      type: 'layers/initLiveLayers',
      payload: props.liveLayers
    })

    const forceRefresh = shouldForceUserRefresh()

    extend(null, forceRefresh)
      .then(response => {
        if (response.success) {
          props.dispatch({
            type: 'user/setCurrentUser',
            payload: response.data
          })
          props.dispatch({
            type: 'map/updateInterceptor'
          })
        } else {
          const logoutAndRedirectUser = () => {
            props.dispatch({
              type: 'user/logout',
              callback: () => {
                window.location.replace(props.appConfig.REACT_APP_GOHUNT_CMS_URL + '/user/login?destination=/maps')
              }
            })
          }
          props.dispatch({
            type: 'modals/add',
            payload: {
              component: Alert,
              props: {
                title: 'Oops, sorry about that.',
                subtitle: 'An authentication issue has occurred and you will need to log back in.',
                message: 'You will be redirected within a few seconds.',
                actionItems: [
                  {
                    title: 'Log In',
                    onClick: () => logoutAndRedirectUser()
                  }
                ]
              }
            }
          })
          setTimeout(() => {
            logoutAndRedirectUser()
          }, 5000)
        }
      })
      .catch(err => {
        console.error('USER FETCH ERR', err)
      })
  }, [])

  return (
    <div style={{ position: 'relative' }}>
      <ModalView />

      <div style={{ display: 'flex' }}>
        {props.loading ? <LoadingScreen /> : null}
        {props.firebaseDone ? (
          <>
            <MainUI />
            <MapView />
          </>
        ) : null}
      </div>
    </div>
  )
}

App.propTypes = {
  appConfig: PropTypes.object,
  basemaps: PropTypes.array,
  firebaseDone: PropTypes.bool,
  liveLayers: PropTypes.array,
  loading: PropTypes.bool
}

export default connect(model => {
  const { firebaseDone, loading } = model.app
  return {
    firebaseDone,
    loading
  }
})(App)
